import { InjectionToken } from '@angular/core';
import { SessionMonitoringConfig } from './session-monitoring.config';

export const SESSION_MONITORING_CONFIG = new InjectionToken<SessionMonitoringConfig>('SESSION_MONITORING_CONFIG');
